import { gql } from '@apollo/client'
import axios from 'axios'
import keycloak from 'src/utils/commonMethods/keycloak'
import { INSURANCE_DETAILS } from 'src/utils/constants/InsuranceDetails'

export const getUserData = async (userName, userdataToken) => {
  const url = `${process.env.REACT_APP_GATEWAY_URL}/accounts/v1/users?filter-column=userName&filter-value=${userName}&only-mandatory-fields=false`
  const headers = {
    Authorization: `Bearer ${userdataToken}`,
  }
  return await axios
    .get(url, { headers })
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getLoggedInUserData = async (userdataToken, childClientId) => {
  let url = `${process.env.REACT_APP_GATEWAY_URL}/getLoggedInUserRolesAccess`
  if (childClientId) {
    url += `?clientId=${encodeURIComponent(childClientId)}`
  }
  const headers = {
    Authorization: `Bearer ${userdataToken}`,
  }
  return await axios
    .get(url, { headers })
    .then((res) => ({ res }))
    .catch((err) => err)
}

export const getToken = async () => {
  let qs = require('qs')
  let data = qs.stringify({
    client_id: `${process.env.REACT_APP_KEYCLOAK_CLIENT_ID}`,
    username: `${process.env.REACT_APP_GET_TOKEN_USERNAME}`,
    password: `${process.env.REACT_APP_GET_TOKEN_PASSWORD}`,
    grant_type: 'password',
  })
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_KEYCLOAK_URL}/auth/realms/PaisaPlan/protocol/openid-connect/token`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: data,
  }

  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getTokenForQrReport = async () => {
  let qs = require('qs')
  let data = qs.stringify({
    client_id: `${process.env.REACT_APP_KEYCLOAK_CLIENT_ID}`,
    username: `${process.env.REACT_APP_QRCODE_USERNAME}`,
    password: `${process.env.REACT_APP_QRCODE_PASSWORD}`,
    grant_type: 'password',
  })
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_KEYCLOAK_URL}/auth/realms/PaisaPlan/protocol/openid-connect/token`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: data,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}
export const getPolicyInfoFromQr = async (token, policyNumber) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/getQRInfo?policyId=${policyNumber}`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getMemberDataFromQr = async (token, employeeId, employerId) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/getQRInfo/memberData?employeeId=${employeeId}&employerId=${employerId}`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}
export const registerUser = async (
  firstName,
  personalEmailId,
  mobileNumber,
  userName,
  captchaResponse,
  result,
  lastName,
  mergeAccept
) => {
  const requestBody = {
    firstName,
    personalEmailId,
    mobileNumber,
    userName,
    captchaResponse,
    lastName,
    mergeAccept,
  }
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/register/verify`,
    headers: { Authorization: `Bearer ${result}` },
    data: requestBody,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}
export const validateOtp = async (
  mailOtp,
  smsOtp,
  userName,
  mobileNumber,
  firstName,
  personalEmailId,
  lastName,
  result,
  captchaResponse,
  mergeAccept = true
) => {
  const requestBody = {
    mailOtp,
    smsOtp,
    userName,
    mobileNumber,
    firstName,
    personalEmailId,
    lastName,
    captchaResponse,
    mergeAccept,
  }

  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/register/submit`,
    headers: { Authorization: `Bearer ${result}` },
    data: requestBody,
  }
  return await axios(config).then((res) => {
    return { res }
  })
}

export function invokeAllTypesSXP(body, user, dialogType) {
  const url = `${process.env.REACT_APP_SOCKET_URL}state/projectId/${process.env.REACT_APP_GET_SXP_PROJECT_ID}`
  let data = { userId: `${user}`, message: '::restart', version: 'WORKING' }
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_SOCKET_URL}message/process/projectId/${process.env.REACT_APP_GET_SXP_PROJECT_ID}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${keycloak.token}`,
    },
    data: data,
  }

  return axios(config)
    .then(() => {
      axios
        .put(url, body, {
          headers: { Authorization: `Bearer ${keycloak.token}` },
        })
        .then((response) => {
          window['chatSendMsg'](`${dialogType}`, user)
          return response
        })
    })
    .catch((err) => {
      return err
    })
}
export const updateUser = async (
  type,
  mOtp,
  result,
  mobileNumber,
  eOtp,
  emailId
) => {
  const requestBodyMobile = {
    channel: 'mobile',
    to: `91${mobileNumber}`,
    from: '7709234181',
    subject: 'Otp Generation',
    body: '${otp} is the OTP for verification. DO NOT disclose it to anyone. Trovity Team.',
  }
  const helpMobile = `${INSURANCE_DETAILS.HELP_MOBILE}`
  const requestBodyEmail = {
    channel: 'email',
    to: `${emailId}`,
    from: 'noreply@techsophy.com',
    subject: 'OTP Verification',
    templateId: '61ded3d207868444639e024f',
    templateData: {
      iconLogo:
        'https://paisaplan.s3.ap-south-1.amazonaws.com/dev/public/emailTemplateIcons/trovity.jpg',
      otpImage:
        'https://paisaplan.s3.ap-south-1.amazonaws.com/dev/public/emailTemplateIcons/otp.jpg',
      contactNumber: `${helpMobile}`,
      emailID: 'help@trovity.com',
      otp: '${otp}',
    },
  }
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/accounts/v1/otp/generate`,
    headers: { Authorization: `Bearer ${result}` },
    data: type === 'mobile' ? requestBodyMobile : requestBodyEmail,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export function PORTFOLIO_List(client, policyHolderType) {
  return gql`query GET_PORTFOLIO {
    getPortfolioList(page: 0,  sort: null, clientId: "${client}", clientType: ${policyHolderType}) {
      content {
        id
        insuranceTypes
       statuses
        clientId
        providerIds
        policies {
          id
          clientId
          status
          familyDefinition
          otherInformation{
            insuredName
            vehicleNumber
            vehicleMakeModel
            tpa
            location
            branch
            }
          policyHolder {
            type
          }
          issuedOn
          expiresOn
          premiumAmount {
            text
          }
          claimAmount {
            text
          }
          productImage
          sumAssured {
            text
          }
          coverageUpto {
            text
          }
          provider {
            id
            image
            name
          }
          type
          productSubType
          insuranceType
          coverageTypes
          coverageDocumentURL
          coverageDocument {
            name
            data {
              id
            }
          }
          fileName
          agentComments
        }
      }
    }
  }`
}
export function PORTFOLIO_List_NEW(client, policyHolderType) {
  return gql`
    query {
      getPortfolioV2(clientId: "${client}", clientType: ${policyHolderType}) {
        ctc
        riskScore {
          healthInsurance {
            score
            recommendedValue {
              values
              type
            }
          }
          accidentalInsurance {
            score
            recommendedValue {
              values
              type
            }
          }
          lifeInsurance {
            score
            recommendedValue {
              values
              type
            }
          }
        }
        overallSuggestions{
          priority
          insuranceName
          subTypeName
          riskPercent
          riskLevel
          personalPolicies{
              id
              insuranceType
              subType
              priority
              coverageTypes
              comment
              action
              insuranceTypeImage
          }
          missingPolicies{
              insuranceType
              subType
              priority
              comment
              action
              insuranceTypeImage
              premiumPaid
              sumAssured
          }
      }
        data {
          logo
          aggregated
          insuranceMainName
          insuranceSubTypeName
          recommended {
            values
            type
          }
          company {
            sumAssured
            premium
            claims
          }
          personal {
            sumAssured
            premium
            claims
          }
          coverages {
            coverageName
            coverageDescription
            available
          }
          companyPolicies {
            agentComments
            sysAnnexureDocumentURL
            sysAnnexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            coverageDocumentURL
            coverageDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            coverageTypes
            fileName
            policyDocumentURL
            policyNumber
            policyDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            annexureDocumentURL
            annexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            id
            status
            clientId
            otherInformation {
              insuredName
              vehicleNumber
              vehicleMakeModel
              tpa
              location
              branch
            }
            familyDefinition
            policyHolder {
              id
              type
              firstName
              lastName
              policyMembers {
                firstName
                lastName
                dateOfBirth
                relation
              }
              policyId
            }
            issuedOn
            expiresOn
            premiumAmount {
              text
            }
            claimAmount {
              text
            }
            productImage
            sumAssured {
              text
            }
            coverageUpto {
              text
            }
            provider {
              id
              name
              image
            }
            otherInformation {
              insuredName
              vehicleNumber
              vehicleMakeModel
              tpa
              location
              branch
            }
            type
            insuranceType
            productSubType
            policyType
            typeOfPolicy 
            intermediary
          }
          personalPolicies {
            agentComments
            sysAnnexureDocumentURL
            sysAnnexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            coverageDocumentURL
            coverageDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            coverageTypes
            fileName
            policyDocumentURL
            policyNumber
            policyDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            annexureDocumentURL
            annexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            id
            status
            clientId
            familyDefinition
            policyHolder {
              id
              type
              firstName
              lastName
              policyMembers {
                firstName
                lastName
                dateOfBirth
                relation
              }
              policyId
            }
            issuedOn
            expiresOn
            premiumAmount {
              text
            }
            claimAmount {
              text
            }
            productImage
            sumAssured {
              text
            }
            coverageUpto {
              text
            }
            provider {
              id
              name
              image
            }
            otherInformation {
              insuredName
              vehicleNumber
              vehicleMakeModel
              tpa
              location
              branch
            }
            type
            insuranceType
            productSubType
            policyType
            typeOfPolicy 
            intermediary
          }
        }
      }
    }
  `
}
export function MEMBER_PAGE_DETAILS() {
  return gql`
    query (
      $search: String
      $page: Int
      $policyID: String!
      $filter: [String]
      $clientId: String!
      $viewForCEO: Boolean
    ) {
      getMemberPage(
        page: $page
        size: 10000000
        policyId: $policyID
        filter: $filter
        search: $search
        clientId: $clientId
        viewForCEO: $viewForCEO
      ) {
        filter
        content {
          id
          empId
          employerId
          firstName
          middleName
          lastName
          numberOfMember
          ctc
          dateOfBirth
          dateOfJoining
          location
          relation
          sumAssured {
            text
          }
          healthCardURL
          healthCards {
            name
            data {
              id
            }
          }
          dependents {
            id
            firstName
            middleName
            lastName
            dateOfBirth
            location
            healthCardURL
            healthCards {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            relation
            sumAssured {
              text
            }
          }
        }
        pageInfo {
          currentPage
          totalCount
          totalPages
        }
      }
    }
  `
}

export function POLICY_details(policyId) {
  return gql`
  query myquery{
    getPolicyDetails(id: "${policyId}") {
      locations
      annexureType
      policy {
        agentComments
        id
        clientId
        typeOfPolicy
        intermediary
        status
        otherInformation{
          insuredName 
          vehicleNumber          
          vehicleMakeModel
          tpa
          location
          branch
          }
        policyHolder {
          id
          type
          firstName
          lastName
          policyMembers {
            firstName
            lastName
            dateOfBirth
            relation
          }
          policyId
        }
        issuedOn
          expiresOn
          premiumAmount {
            text
          }
          claimAmount {
            text
          }
          productImage
          sumAssured {
            text
          }
          coverageUpto {
            text
          }
          provider {
            id
            image
            name
          }
          type
          productSubType
          insuranceType
          coverageTypes
          policyDocumentURL
          policyNumber
          policyDocument {
            name
            data {
              id
            }
          }
          annexureDocumentURL
          annexureDocument {
            name
            data {
              id
            }
          }
          coverageTypes
          coverageDocumentURL
          coverageDocument {
            name
            data {
              id
            }
          }
          sysAnnexureDocumentURL
          sysAnnexureDocument {
            name
            data {
              id
            }
          }
      }
    }
  }
`
}
export function ANNEXURE_ASSET() {
  return gql`
    query GET_ASSET_PAGE(
      $search: String!
      $page: Int!
      $policyID: String!
      $filter: [String!]
    ) {
      getAssetPage(
        page: $page
        size: 20
        policyId: $policyID
        filter: $filter
        search: $search
      ) {
        filter
        content {
          id
          policyId
          assetName
          assetNature
          assetCity
          assetLocation
          assetAddress
          assetValue
          assetId
        }
        pageInfo {
          currentPage
          totalCount
          totalPages
        }
      }
    }
  `
}
export function Endorsement_details() {
  return gql`
    query endorsement(
      $page: Int
      $sortField: String
      $sort: String
      $policyId: String!
      $typeFilter: [String]
      $statusFilter: [String]
      $toDate: DateTime
      $fromDate: DateTime
      $clientId: String!
      $viewForCEO: Boolean
    ) {
      getEndorsementPage(
        page: $page
        size: 10000000
        sortField: $sortField
        sort: $sort
        policyId: $policyId
        typeFilter: $typeFilter
        statusFilter: $statusFilter
        toDate: $toDate
        fromDate: $fromDate
        clientId: $clientId
        viewForCEO: $viewForCEO
      ) {
        content {
          id
          policyId
          endorsementType
          endorsementStatus
          createdOn
          updatedOn
          clientId
          clientEndorsementDoc
          clientEndorsement {
            name
            data {
              id
            }
          }
          agentEndorsementCopy
          agentEndorsement {
            name
            data {
              id
            }
          }
          typeImage
        }
        pageInfo {
          currentPage
          totalCount
          totalPages
        }
      }
    }
  `
}

export const upload = gql`
  query GET_uploadDocument {
    getDocumentType(input: SAVEPOLICY) {
      requestType
      uploadDocumentTypes {
        documentType
        isMandatory
        templateURL
      }
    }
  }
`
export function SMARTADVISOR(clientId, clientType) {
  return gql`
    query SMART_ADVISOR {
      smartAdviceList(clientId: "${clientId}", clientType: ${clientType}) {
        id
        explore {
          name
          url
          isVideo
        }
        purchaseJourney
        claims {
          policyIds
          claimsView {
            id
          }
        }
        endorsements {
          policyIds
          endorsementsView {
            id
            policyId
            policyName
            endorsementType
            endorsementStatus
            createdOn
            updatedOn
            clientEndorsementDoc
            clientEndorsement {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            agentEndorsementCopy
            agentEndorsement {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
          }
        }
        riskPolicies{
          name
          url
        }
      }
    }
  `
}

export function KEYNOTES() {
  return gql`
    query ($activePolicyInsuranceType: String!) {
      getKeyPointsFAQData(insuranceType: $activePolicyInsuranceType) {
        faq {
          question

          answer
        }

        keyPoints {
          heading

          content
        }
      }
    }
  `
}
export function CTC_ENTER() {
  return gql`
    mutation ($userName: String!, $ctc: BigDecimal!) {
      changeUserData(input: { ctc: $ctc }, userName: $userName)
    }
  `
}
export function GET_ALL_ENDORSEMENTS() {
  return gql`
    query (
      $page: Int
      $sortField: String
      $sort: String
      $clientId: String!
      $clientType: ClientType
    ) {
      getAllEndorsements(
        page: $page
        size: 20
        sortField: $sortField
        sort: $sort
        clientId: $clientId
        clientType: $clientType
      ) {
        content {
          id
          endorsementType
          endorsementStatus
          email
          createdOn
          metadata
          agentEndorsementCopy
          agentEndorsement {
            name
            data {
              id
            }
          }
          clientEndorsementDoc
          clientEndorsement {
            name
            data {
              id
            }
          }
          policy {
            sysAnnexureDocumentURL
            sysAnnexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            coverageDocumentURL
            coverageDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            fileName
            policyDocumentURL
            policyNumber
            policyDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            id
            fileName
            clientId
            policyHolder {
              id
              type
              firstName
              lastName
              policyMembers {
                firstName
                lastName
                dateOfBirth
                relation
              }
              policyId
            }
            issuedOn
            expiresOn
            renewalOn
            status
            premiumAmount {
              text
            }
            claimAmount {
              text
            }
            productImage
            type
            isCovid19Covered
            insuranceType
            productSubType
            annexureDocumentURL
            annexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            sumAssured {
              text
            }
            claims {
              id
            }
            provider {
              id
              image
            }
          }
        }
        pageInfo {
          currentPage
          totalCount
          totalPages
        }
      }
    }
  `
}

export function TPA(tpaId) {
  return gql`
    query GET_TPA_DATA {
      getTpaData(id: "${tpaId}") {
        id
        name
        url
      }
    }
  `
}
export function LogInTime(userName) {
  return gql`
  mutation {
      updateLoginTime(userName: "${userName}") {
        loggedInAtLeastOnce
      }
    }
  `
}
export function UPDATE_USER_VERIFY() {
  // emailId,
  // emailOTP,
  // mobileNumber,
  // mobileOTP,
  // username
  return gql`
    mutation CHANGE_USERDATA(
      $emailId: String!
      $emailOtp: String
      $mobile: String!
      $mobileOtp: String
      $userName: String!
    ) {
      changeUserData(
        input: {
          emailId: $emailId
          emailOtp: $emailOtp
          mobile: $mobile
          mobileOtp: $mobileOtp
        }
        userName: $userName
      )
    }
  `
}

export const downloadDocument = async (
  fileName,
  documentId,
  documentURL = null
) => {
  const link = document.createElement('a')
  if (documentId) {
    let config = {
      method: 'get',
      url: `${process.env.REACT_APP_GATEWAY_URL}/download/dms/${fileName}/${documentId}`,
      responseType: 'blob',
      headers: { Authorization: `Bearer ${keycloak.token}` },
    }
    return await axios(config).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      link.href = url
      link.setAttribute('download', `${fileName}`)
      link.setAttribute('target', '_blank')
      document.body.appendChild(link)
      link.click()
    })
  } else if (documentURL) {
    link.href = documentURL
    link.setAttribute('download', `${fileName}`)
    link.setAttribute('target', '_blank')
    document.body.appendChild(link)
    link.click()
  } else {
    // do nothing
  }
}

export function TOP_CLAIMS_DATA(client) {
  return gql`
  query {
    getTopClaims(clientId: "${client}") {
        employeeBenefits{
            policyName
          employeeName
          claimAmount
          pendingSince
          remarks
          claimType
          employeeId
          employeeName
          claimantName
          relation
          dateOfBirth
          claimantAge
          gender
          dateOfAdmission
          dateOfDischarge
          ailment
          amountClaimed
          finalApprovedAmount
          claimStatus
          pendingFrom
        }
        nonEmployeeBenefits{
            dateOfLoss
            estClaimAmount
            policyName
            remarks
        }
    }
}
  `
}

export function USER_ANALYTICS_DATA(client) {
  return gql`
    query(
      $queryType: CorporateQueryType
      $with: Boolean
      $search: String
     ) {
      getUsersAnalyticsForCorporate(
        page: 0
        size: 10000000
        clientId: "${client}"
        with: $with
        queryType: $queryType
        search: $search
      ) {
        content {
          id
          empId
          employerId
          firstName
          middleName
          lastName
        }
        pageInfo {
          currentPage
          totalPages
          totalCount
        }
      }
    }
  `
}

export function GET_HEALTHCARD_COUNT() {
  return gql`
    query (
      $healthCardExists: Boolean
      $includeMemberData: Boolean
      $policyId: Long
    ) {
      getHealthCardData(
        healthCardExists: $healthCardExists
        includeMemberData: $includeMemberData
        policyId: $policyId
      ) {
        count
        data {
          id
          empId
          employerId
          firstName
          middleName
          lastName
        }
      }
    }
  `
}

export const downloadUpcomingRenewalsExcel = async (
  clientId,
  insuranceType
) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/download/policyDetails`,
    responseType: 'blob',
    headers: { Authorization: `Bearer ${keycloak.token}` },
    params: {
      clientId,
      insuranceType,
    },
  }
  return await axios(config)
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `PolicyDetails-${clientId}.xlsx`)
      document.body.appendChild(link)
      link.click()
    })
    .catch((error) => {
      return error
    })
}

export function DASHBOARD_POLICIES_DATA(
  clientId,
  clientType,
  expiryType,
  year,
  insuranceType,
  insuranceSubType,
  city
) {
  return gql`
  query {
    getDashboardPoliciesAggregate(clientId: "${clientId}", clientType: ${clientType} ,expiryType:${expiryType}, year:"${year}", insuranceType:"${insuranceType}", insuranceSubType:"${insuranceSubType}", city:"${city}") {
        totalPolicies
        totalPremiumAmount
        activePolicies
        verificationPendingPolicies
        expiredPolicies
        expiringPolicies
        policiesAggregate{
            policyType
            logo
            statistics{
            totalNumberOfPolicies
            totalSumAssuredAmount
            expired
            expiring
            digitalizing
            }
            totalPremium
            categoryFusion
        }
    }
  }
  `
}

export function GET_DASHBOARD_POLICIES_GROUP_AGGREGATE(
  clientId,
  policyType,
  sortBy,
  search,
  expiryType,
  year,
  insuranceType,
  insuranceSubType,
  city
) {
  return gql`
  query {
    getDashboardPoliciesGroupedData(clientId: "${clientId}", clientType: CORPORATE, 
    policyType: "${policyType}",sortBy: ${sortBy}, search: "${search}", expiryType:${expiryType}, year:"${year}", insuranceType:"${insuranceType}", insuranceSubType:"${insuranceSubType}", city:"${city}" ) {
      policyType
      policies {
        oldPolicyId
        renewedPolicyId
        agentComments
        sysAnnexureDocumentURL
            sysAnnexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            coverageDocumentURL
            policyUploadedMethod
            coverageDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            coverageTypes
            individualCoverageTypes
            fileName
            policyDocumentURL
            policyNumber
            coverRange
            policyDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            annexureDocumentURL
            annexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            id
            status
            clientId
            otherInformation {
              insuredName
              vehicleNumber
              vehicleMakeModel
              tpa
              location
              branch
              city
              state
              address
            }
            familyDefinition
            policyHolder {
              id
              type
              firstName
              lastName
              policyMembers {
                firstName
                lastName
                dateOfBirth
                relation
              }
              policyId
            }
            issuedOn
            expiresOn
            premiumAmount {
              text
            }
            claimAmount {
              text
            }
            productImage
            sumAssured {
              text
            }
            coverageUpto {
              text
            }
            provider {
              id
              name
              image
            }
            otherInformation {
              insuredName
              vehicleNumber
              vehicleMakeModel
              tpa
              location
              branch
              ncbPercentage
              seatingCapacity
              fuelType
              cc
              vehicleIdv
              gvw
            }
            type
            insuranceType
            productSubType
            isCompanyPolicy
            policyType
            typeOfPolicy 
            intermediary
            totalNoOfEmployees
            isNearToExpire
            paymentType
            installmentDetails {
              installmentNo
              installmentDate
              installmentAmount
            }
    }
    }
  }
  `
}

export const getLogo = async (clientId) => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/download/${clientId}/`,

    headers: { Authorization: `Bearer ${keycloak.token}` },
  }
  return await axios(config).then((res) => {
    return { res }
  })
}

export const GET_PERSONAL_POLICIES = (
  clientId,
  expiryType,
  year,
  insuranceType,
  insuranceSubType
) => {
  return gql`
    query {
      getPersonalPolicies(clientId: "${clientId}", clientType: INDIVIDUAL, expiryType:${expiryType}, year:"${year}", insuranceType:"${insuranceType}", insuranceSubType:"${insuranceSubType}") {
        totalPolicies
        totalPremiumAmount
        expiredPolicies
        expiringPolicies
        activePolicies
        verificationPendingPolicies
        policies {
        oldPolicyId
        renewedPolicyId
        agentComments
           sysAnnexureDocumentURL
            sysAnnexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            coverageDocumentURL
            policyUploadedMethod
            coverageDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            coverageTypes
            individualCoverageTypes
            fileName
            policyDocumentURL
            policyNumber
            coverRange
            policyDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            annexureDocumentURL
            annexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            id
            status
            clientId
            companyName
            otherInformation {
              insuredName
              vehicleNumber
              vehicleMakeModel
              tpa
              city
              state
              address
              vehicleIdv
              cc
              ncbPercentage
              gvw
              seatingCapacity
              fuelType
            }
            familyDefinition
            policyHolder {
              id
              type
              firstName
              lastName
              policyMembers {
                firstName
                lastName
                dateOfBirth
                relation
                healthCardURL
                healthCards {
                  name
                  data {
                    id
                  }
                }
              }
              policyId
            }
            issuedOn
            expiresOn
            premiumAmount {
              text
            }
            claimAmount {
              text
            }
            productImage
            sumAssured {
              text
            }
            coverageUpto {
              text
            }
            provider {
              id
              name
              image
            }
            type
            insuranceType
            productSubType
            policyType
            typeOfPolicy 
            intermediary
            totalNoOfEmployees
            isCompanyPolicy
            isCovid19Covered
            isNearToExpire
            paymentType
            installmentDetails {
              installmentNo
              installmentDate
              installmentAmount
            }
        }
      }
    }
  `
}

export const getClaimAssure = async (formData) => {
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/claimInsurance`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${keycloak.token}`,
    },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export function GET_INSURANCE_TYPES() {
  return gql`
    {
      getMasterData(input: [INSURANCETYPEDATA]) {
        response {
          dataType
          data
        }
      }
    }
  `
}

export function GET_ACCOUNT_MANAGER_DETAILS(clientId) {
  return gql`
  query  
  {
    getAccountManagerDetails(clientId:"${clientId}") {
      message
      success
      accountManagerDetails {
        id
        firstName
        lastName
        mail
        phoneNumber
        imageUrL
      }
    }
  }`
}

export function UPDATE_MOBILE_NUMBER() {
  // userId,
  // existingMobileNumber,
  // newMobileNumber
  return gql`
    mutation UPDATE_MOBILE_NUMBER(
      $updateMobileNumberRequest: UpdateMobileNumberRequest
    ) {
      updateUserMobileNumber(
        updateMobileNumberRequest: $updateMobileNumberRequest
      ) {
        success
        message
        userId
      }
    }
  `
}

export function RAISE_REQUEST() {
  return gql`
    mutation RAISE_REQUEST($emailsDetails: DashboardEmailsDetails) {
      triggerEmail(emailsDetails: $emailsDetails) {
        message
      }
    }
  `
}

// export function GET_ACCOUNT_MANAGER_DETAILS(clientId) {
//   return gql`
//   query
//   {
//     getAccountManagerDetails(clientId:"${clientId}") {
//       message
//       success
//       accountManagerDetails {
//         id
//         firstName
//         lastName
//         mail
//         phoneNumber
//         imageUrL
//       }
//     }
//   }`;
// }

// export function GET_INSURANCE_TYPES() {
//   return gql`
//     {
//       getMasterData(input: [INSURANCETYPEDATA]) {
//         response {
//           dataType
//           data
//         }
//       }
//     }
//   `;
// }

export const getBuyInsurance = async (formData) => {
  const config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/buyInsurance`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${keycloak.token}`,
    },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export function invokeKhsSXP(body, user, dialogType) {
  const url = `${process.env.REACT_APP_SOCKET_URL}state/projectId/${process.env.REACT_APP_GET_SXP_KHS_PROJECT_ID}`
  let data = { userId: `${user}`, message: '::restart', version: 'WORKING' }
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_SOCKET_URL}message/process/projectId/${process.env.REACT_APP_GET_SXP_KHS_PROJECT_ID}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${keycloak.token}`,
    },
    data: data,
  }

  return axios(config)
    .then(() => {
      axios
        .put(url, body, {
          headers: { Authorization: `Bearer ${keycloak.token}` },
        })
        .then((response) => {
          window['chatSendMsg'](`${dialogType}`, user)
          return response
        })
    })
    .catch((err) => {
      return err
    })
}

export function GET_CORPORATE_EMPLOYEE_DETAILS() {
  return gql`
    query ($userType: UserType, $clientId: String, $search: String) {
      getUserDetails(
        userType: $userType
        clientId: $clientId
        search: $search
      ) {
        usersDetails {
          userName
          employeeId
          mobileNumber
          email
        }
        count
      }
    }
  `
}

export function GET_HEALTHCARD_DETAILS() {
  return gql`
    query ($policyId: Long) {
      getCorporateEmployeeCount(policyId: $policyId) {
        employeeWithHealthCardCount
        employeeWithoutHealthCardCount
        totalEmployeeCount
      }
    }
  `
}

export const getHNIReports = async (token, userName) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/hniclient/${userName}`,
    headers: { Authorization: `Bearer ${keycloak.token}` },
    // data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export function UPDATE_NOTIFICATION_SETTINGS() {
  return gql`
    mutation UPDATE_NOTIFICATION_SETTINGS(
      $notificationsSettings: ClientNotificationTriggersInput
    ) {
      saveOrUpdateNotificationsSettings(
        notificationsSettings: $notificationsSettings
      ) {
        message
      }
    }
  `
}

export function FETCH_NOTIFICATION_SETTINGS(clientId) {
  return gql`
    query {
      fetchClientsNotificationsSettingsData(clientId: "${clientId}") {
        message
        success
        clientNotificationSettings {
          id
          clientId
          policyUploadReminder
          loginReminder
          policyExpiredReminder
          policyExpiringReminder
        }
      }
    }
  `
}

export function FETCH_ALL_CD_ACCOUNTS_FOR_CLIENTS(clientId) {
  return gql`
    query {
      fetchAllCdAccountsForClient(clientId: "${clientId}") {
        success
        message
        data {
          id
          clientId
          cdAccountsDetails {
            cdAccountId
            cdAccountNumber
            currentCdAccountBalance
            createdBy {
              id
              userName
              firstName
              lastName
            }
            createdOn
            lastUpdatedOn
            linkedPolicies {
              oldPolicyId
              agentComments
              id
              clientId  
              status
                otherInformation{
                  insuredName
                  vehicleNumber
                  vehicleMakeModel
                  tpa
                  location
                  branch
                }

              policyHolder {
                type
                policyMembers {
                  id
                  firstName
                  middleName
                  lastName
                }
              }
              issuedOn
              expiresOn
              premiumAmount {
                text
              }
              claimAmount {
                text
              }
              productImage
              sumAssured {
                text
              }
              coverageUpto {
                text
              }
              provider {
                id
                image
                name
              }
              type
              productSubType
              insuranceType
              coverageTypes
              policyDocumentURL
              policyNumber
              policyDocument {
                name
                originalName
                size
                storage
                type
                url
                data {
                  id
                  baseUrl
                  form
                  project
                  version
                }
              }
              annexureDocumentURL
              annexureDocument {
                name
                originalName
                size
                storage
                type
                url
                data {
                  id
                  baseUrl
                  form
                  project
                  version
                }
              }
              coverageTypes
             coverageDocumentURL
             coverageDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            sysAnnexureDocumentURL
            sysAnnexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            }
          }
        }
      }
    }
  `
}

export function GET_POLICY_LINKED_TO_CD_ACCOUNT(clientId, id) {
  return gql`
    query {
      getPolicyLinkedToCdAccount(clientId: "${clientId}", cdAccountId: "${id}") {
        success
        message
        content {
          cdAccountId
          currentCdAccountBalance
          cdAccountNumber
          createdOn
          lastUpdatedOn
          linkedPolicies  {
              oldPolicyId
              agentComments
              id
              clientId  
              status
                otherInformation{
                  insuredName
                  vehicleNumber
                  vehicleMakeModel
                  tpa
                  location
                  branch
                }

              policyHolder {
                type
                policyMembers {
                  id
                  firstName
                  middleName
                  lastName
                }
              }
              issuedOn
              expiresOn
              premiumAmount {
                text
              }
              claimAmount {
                text
              }
              productImage
              sumAssured {
                text
              }
              coverageUpto {
                text
              }
              provider {
                id
                image
                name
              }
              type
              productSubType
              insuranceType
              coverageTypes
              policyDocumentURL
              policyNumber
              totalNoOfEmployees
              noOfPermanentEmployees
              noOfContractEmployees
              noOfEmployeesCovered
              noOfLivesCovered
              avgFamilySize
              definitionOfFamily
              policyDocument {
                name
                originalName
                size
                storage
                type
                url
                data {
                  id
                  baseUrl
                  form
                  project
                  version
                }
              }
              annexureDocumentURL
              annexureDocument {
                name
                originalName
                size
                storage
                type
                url
                data {
                  id
                  baseUrl
                  form
                  project
                  version
                }
              }
              coverageTypes
             coverageDocumentURL
             coverageDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            sysAnnexureDocumentURL
            sysAnnexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            }
        }
      }
    }
  `
}

export function FETCH_CD_ACCOUNT_TRACK_DETAILS(cdAccountId) {
  return gql`
    query {
      trackCdAccountsTransactions(cdAccountId: "${cdAccountId}") {
        success
        message
        transactions
        {
            id
            cdAccountId
            cdAccountNumber
            balance
            policyIds
            policyTypes
            transactionType
            updatedBy
            {
                id
                userName
                firstName
                lastName
            }
            updatedOn
        }
      }
    }
  `
}

export function GET_CLIENT_BY_YEARS(clientId) {
  return gql`
    query {
      getExpiredPoliciesYearLimit(clientId: "${clientId}") {
        success
        message
        data {
          expiredPolicyYearLimitMin
          expiredPolicyYearLimitHigh
        }
      }
    }
  `
}

export function UPLOAD_POLICY_DOCUMENT() {
  return gql`
    mutation (
      $file: Upload
      $clientId: String
      $clientType: String
      $oldPolicyId: String
    ) {
      uploadDocumentForPolicyRenewal(
        document: $file
        clientId: $clientId
        clientType: $clientType
        oldPolicyId: $oldPolicyId
      ) {
        message
        success
      }
    }
  `
}

export function GET_TRACKED_DETAILS_FOR_POLICIES(policyId) {
  return gql`
    query {
      getTrackedDetailsForPolicy(policyId: "${policyId}") {
        message
        success
        policyDetails {
        oldPolicyId
        renewedPolicyId
        renewedBy{
          id
          userName
          firstName
          lastName
        }
        renewalOn
        agentComments
           sysAnnexureDocumentURL
            sysAnnexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            coverageDocumentURL
            policyUploadedMethod
            coverageDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            coverageTypes
            individualCoverageTypes
            fileName
            policyDocumentURL
            policyNumber
            coverRange
            policyDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            annexureDocumentURL
            annexureDocument {
              name
              originalName
              size
              storage
              type
              url
              data {
                id
                baseUrl
                form
                project
                version
              }
            }
            id
            status
            clientId
            otherInformation {
              insuredName
              vehicleNumber
              vehicleMakeModel
              tpa
              location
              branch
              state
              city
              location
              address
            }
            familyDefinition
            policyHolder {
              id
              type
              firstName
              lastName
              policyMembers {
                firstName
                lastName
                dateOfBirth
                relation
              }
              policyId
            }
            issuedOn
            expiresOn
            premiumAmount {
              text
            }
            claimAmount {
              text
            }
            productImage
            sumAssured {
              text
            }
            coverageUpto {
              text
            }
            provider {
              id
              name
              image
            }
            otherInformation {
              insuredName
              vehicleNumber
              vehicleMakeModel
              tpa
              location
              branch
              vehicleIdv
              gvw
              ncbPercentage
              cc
              seatingCapacity
              fuelType
            }
            type
            insuranceType
            productSubType
            policyType
            typeOfPolicy 
            intermediary
            totalNoOfEmployees
            paymentType
            installmentDetails {
              installmentNo
              installmentDate
              installmentAmount
            }
    }
      }
    }
  `
}

export function GET_RENEWAL_POLICY_SAVED_DATA(oldPolicyId) {
  return gql`
    query {
      getRenewalPolicySavedData(oldPolicyId: "${oldPolicyId}") {
        message
        success
        data {
          typeOfPolicy
          intermediary
          decision
          totalNoOfEmployees
          coverRange
          firstName
          lastName
          mobileNumber
          email
          policyType
          policyNumber
          clientId
          type
          insuranceType
          productSubType
          provider {
            id
            name
          }
          sumAssured
          coverageTypes
          issuedOn
          expiresOn
          premiumAmount
          claimAmount
          agentComments
          tpa
          cityLocation
          branch
          empMigration
          policyDocument {
            name
            originalName
            category
            size
            storage
            type
            url
            data {
              baseUrl
              form
              id
              project
              version
            }
          }
          policyUploadedMethod
          oldPolicyId
          renewedPolicyIds
          policyHolder {
            id
            firstName
            lastName
            type
            policyMembers {
              id
              empId
              employerId
              firstName
              middleName
              lastName
              coverStartDate
              coverEndDate
              numberOfMember
              isCovered
              primaryPolicyMemberId
              relation
              healthCards {
                name
                originalName
                category
                size
                storage
                type
                url
                data {
                  baseUrl
                  form
                  id
                  project
                  version
                }
                linkedPolicyId
                timeStamp
              }
              dateOfBirth
              dateOfJoining
              location
            }
            policyId
          }
          status
          createdOn
          updatedOn
          createdBy
          updatedBy
          renewalOn
          insuredName
          vehicleNumber
          vehicleMakeModel
        }
      }
    }
  `
}

export function GET_MASTER_DATA() {
  return gql`
    query {
      getInsuranceTypeData(clientType: null) {
        id
        productType
        insuranceType
        subType
        category
      }
    }
  `
}

export function GET_INSURANCE_PROVIDER_DATA() {
  return gql`
    query GET_MASTER_DATA {
      getMasterData(input: PROVIDERDATA) {
        response {
          dataType
          data
        }
      }
    }
  `
}

export function GET_TPA_DATA() {
  return gql`
    query GET_MASTER_DATA {
      getMasterData(input: TPADATA) {
        response {
          dataType
          data
        }
      }
    }
  `
}

export function SAVE_AND_SUBMIT_RENEWAL_FORM() {
  return gql`
    mutation (
      $policyDocument: Upload
      $renewalAction: RenewalAction
      $oldPolicyId: String
      $policyDetails: RenewalPolicy
    ) {
      saveAsDraftOrCreateRenewedPolicy(
        policyDocument: $policyDocument
        renewalAction: $renewalAction
        oldPolicyId: $oldPolicyId
        policyDetails: $policyDetails
      ) {
        message
      }
    }
  `
}

export function DETACH_MEMBER_FROM_POLICY() {
  return gql`
    mutation (
      $clientId: String
      $memberDetails: [EmployeeDOLRequest]
      $inGpa: String
      $inGtl: String
      $inGmc: String
    ) {
      deleteMemberData(
        input: {
          clientId: $clientId
          memberDetails: $memberDetails
          inGpa: $inGpa
          inGtl: $inGtl
          inGmc: $inGmc
        }
      ) {
        clientId
        message
        success
      }
    }
  `
}

export function SAVE_POLICY_COVERAGES() {
  return gql`
    mutation (
      $policyId: String!
      $coverageTypes: String!
      $individualCoverageTypes: String!
    ) {
      savePolicy(
        input: {
          id: $policyId
          coverageTypes: $coverageTypes
          individualCoverageTypes: $individualCoverageTypes
        }
      ) {
        serviceRequestStatus
        serviceRequestId
        policy {
          agentComments
          id
          clientId
          policyHolder {
            id
            firstName
            lastName
            type
          }
          issuedOn
          expiresOn
          status
          premiumAmount {
            text
          }
          claimAmount {
            text
          }
          productImage
          sumAssured {
            text
          }
          coverageUpto {
            text
          }
          provider {
            id
            name
            image
          }
          type
          isCovid19Covered
          insuranceType
          productSubType
        }
      }
    }
  `
}

export const GET_POLICY_CITIES = gql`
  query GetPolicyCities($policyIds: [Long]) {
    getPolicyCities(policyIds: $policyIds) {
      city
      count
    }
  }
`
